import { DEFAULT_TOAST_LIFE } from "../../../../common/EzToast";
import { affiliateServices } from "../../../../services";
import {
  FETCH_AFFILIATE_INVOICE_INIT,
  FETCH_AFFILIATE_INVOICE_LIST,
  GENERATE_AFFILIATE_INVOICE,
  DOWNLOAD_AFFILIATE_INVOICE,
  UPDATE_AFFILIATE_INVOICE,
  FETCH_AFFILIATE_INVOICE_PAYMENTS,
  RECORD_AFFILIATE_PAYMENT,
  UPDATE_AFFILIATE_PAYMENT,
  GET_AFFILIATE_INVOICE_DETAIL,
  TOAST,
  SET_AFFILIATE_INVOICE_FILTERS,
  CLEAR_AFFILIATE_INVOICE_FILTERS,
  SAVE_AFFILIATE_INVOICE_TABLE_STATE,
  EXPORT_AFFILIATE_INVOICE,
} from "../../../types/affiliateInvoice.type";

export const initializeAffiliateInvoiceScreen = () => ({
  type: FETCH_AFFILIATE_INVOICE_INIT,
});

export const affiliateInvoiceFetchStart = (payload) => ({
  type: FETCH_AFFILIATE_INVOICE_LIST.START,
  payload,
});

export const affiliateInvoiceFetchSuccess = (payload) => ({
  type: FETCH_AFFILIATE_INVOICE_LIST.SUCCESS,
  payload,
});

export const affiliateInvoiceFetchError = (payload) => ({
  type: FETCH_AFFILIATE_INVOICE_LIST.ERROR,
  payload,
});

export const fetchAffiliateInvoice = (payload) => {
  return (dispatch) => {
    dispatch(affiliateInvoiceFetchStart(payload));
    affiliateServices.fetchAffiliateInvoice(payload).then((data) => {
      if (!data.isError) {
        dispatch(affiliateInvoiceFetchSuccess(data));
      } else {
        dispatch(affiliateInvoiceFetchError(data));
      }
    });
  };
};

export const setAffiliateInvoiceFilters = (payload) => ({
  type: SET_AFFILIATE_INVOICE_FILTERS,
  payload,
});

export const clearAffiliateInvoiceFilters = () => ({
  type: CLEAR_AFFILIATE_INVOICE_FILTERS,
});

export const saveAffiliateInvoiceTableState = (payload) => ({
  type: SAVE_AFFILIATE_INVOICE_TABLE_STATE,
  payload,
});

export const resetToast = (payload) => ({
  type: TOAST.RESET,
  payload,
});

export const generateAffiliateInvoiceStart = () => ({
  type: GENERATE_AFFILIATE_INVOICE.START,
});

export const generateAffiliateInvoiceSuccess = (payload) => ({
  type: GENERATE_AFFILIATE_INVOICE.SUCCESS,
  payload,
});

export const generateAffiliateInvoiceError = (payload) => ({
  type: GENERATE_AFFILIATE_INVOICE.ERROR,
  payload,
});

export const generateAffiliateInvoice = (payload) => {
  return (dispatch) => {
    dispatch(generateAffiliateInvoiceStart());
    affiliateServices.generateAffiliateInvoice(payload).then((data) => {
      if (!data.isError) {
        dispatch(generateAffiliateInvoiceSuccess(data));
        dispatch(fetchAffiliateInvoice({ page: 1, pageSize: 10 }));
      } else {
        dispatch(generateAffiliateInvoiceError(data));
      }
      setTimeout(() => {
        dispatch(resetToast());
      }, DEFAULT_TOAST_LIFE + 1000);
    });
  };
};

export const downloadAffiliateInvoiceStart = () => ({
  type: DOWNLOAD_AFFILIATE_INVOICE.START,
});

export const downloadAffiliateInvoiceSuccess = (payload) => ({
  type: DOWNLOAD_AFFILIATE_INVOICE.SUCCESS,
  payload,
});

export const downloadAffiliateInvoiceError = (payload) => ({
  type: DOWNLOAD_AFFILIATE_INVOICE.ERROR,
  payload,
});

export const downloadAffiliateInvoice = (invoiceId) => {
  return (dispatch) => {
    dispatch(downloadAffiliateInvoiceStart());
    affiliateServices.downloadAffiliateInvoicePdf(invoiceId).then((data) => {
      if (!data.isError) {
        dispatch(downloadAffiliateInvoiceSuccess(data));
        // Download the file
        const blob = new Blob([data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `invoice-${invoiceId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        dispatch(downloadAffiliateInvoiceError(data));
      }
      setTimeout(() => {
        dispatch(resetToast());
      }, DEFAULT_TOAST_LIFE + 1000);
    });
  };
};

export const updateAffiliateInvoiceStart = () => ({
  type: UPDATE_AFFILIATE_INVOICE.START,
});

export const updateAffiliateInvoiceSuccess = (payload) => ({
  type: UPDATE_AFFILIATE_INVOICE.SUCCESS,
  payload,
});

export const updateAffiliateInvoiceError = (payload) => ({
  type: UPDATE_AFFILIATE_INVOICE.ERROR,
  payload,
});

export const updateAffiliateInvoice = (invoiceId, status, currentParams, extraData) => {
  return (dispatch) => {
    dispatch(updateAffiliateInvoiceStart());
    affiliateServices.updateAffiliateInvoiceStatus(invoiceId, status, extraData).then((data) => {
      if (!data.isError) {
        dispatch(updateAffiliateInvoiceSuccess(data));
        if (currentParams) {
          dispatch(fetchAffiliateInvoice(currentParams));
        }
      } else {
        dispatch(updateAffiliateInvoiceError(data));
      }
      setTimeout(() => {
        dispatch(resetToast());
      }, DEFAULT_TOAST_LIFE + 1000);
    });
  };
};

export const fetchAffiliateInvoicePaymentsStart = (payload) => ({
  type: FETCH_AFFILIATE_INVOICE_PAYMENTS.START,
  payload,
});

export const fetchAffiliateInvoicePaymentsSuccess = (payload) => ({
  type: FETCH_AFFILIATE_INVOICE_PAYMENTS.SUCCESS,
  payload,
});

export const fetchAffiliateInvoicePaymentsError = (payload) => ({
  type: FETCH_AFFILIATE_INVOICE_PAYMENTS.ERROR,
  payload,
});

export const fetchAffiliateInvoicePayments = (payload = {}) => {
  const { invoiceId, page = 1, size = 10 } = payload;
  return (dispatch) => {
    dispatch(fetchAffiliateInvoicePaymentsStart({ invoiceId }));
    affiliateServices.fetchAffiliateInvoicePayments({ invoiceId, page, size }).then((data) => {
      if (!data.isError) {
        dispatch(fetchAffiliateInvoicePaymentsSuccess({ invoiceId, data }));
      } else {
        dispatch(fetchAffiliateInvoicePaymentsError({ invoiceId, error: data }));
      }
    });
  };
};

export const recordAffiliatePaymentStart = () => ({
  type: RECORD_AFFILIATE_PAYMENT.START,
});

export const recordAffiliatePaymentSuccess = (payload) => ({
  type: RECORD_AFFILIATE_PAYMENT.SUCCESS,
  payload,
});

export const recordAffiliatePaymentError = (payload) => ({
  type: RECORD_AFFILIATE_PAYMENT.ERROR,
  payload,
});

export const recordAffiliatePayment = (payload, invoiceId) => {
  return (dispatch) => {
    dispatch(recordAffiliatePaymentStart());
    affiliateServices.recordAffiliatePayment(payload).then((data) => {
      if (!data.isError) {
        dispatch(recordAffiliatePaymentSuccess(data));
        // Refresh payments after successful recording
        if (invoiceId) {
          dispatch(fetchAffiliateInvoicePayments({ invoiceId }));
        }
      } else {
        dispatch(recordAffiliatePaymentError(data));
      }
      setTimeout(() => {
        dispatch(resetToast());
      }, DEFAULT_TOAST_LIFE + 1000);
    });
  };
};

export const updateAffiliatePaymentStart = () => ({
  type: UPDATE_AFFILIATE_PAYMENT.START,
});

export const updateAffiliatePaymentSuccess = (payload) => ({
  type: UPDATE_AFFILIATE_PAYMENT.SUCCESS,
  payload,
});

export const updateAffiliatePaymentError = (payload) => ({
  type: UPDATE_AFFILIATE_PAYMENT.ERROR,
  payload,
});

export const updateAffiliatePayment = (payload, invoiceId) => {
  return (dispatch) => {
    dispatch(updateAffiliatePaymentStart());
    affiliateServices.updateAffiliatePayment(payload).then((data) => {
      if (!data.isError) {
        dispatch(updateAffiliatePaymentSuccess(data));
        if (invoiceId) {
          dispatch(fetchAffiliateInvoicePayments({ invoiceId }));
        }
      } else {
        dispatch(updateAffiliatePaymentError(data));
      }
      setTimeout(() => {
        dispatch(resetToast());
      }, DEFAULT_TOAST_LIFE + 1000);
    });
  };
};

export const getAffiliateInvoiceDetailStart = () => ({
  type: GET_AFFILIATE_INVOICE_DETAIL.START,
});

export const getAffiliateInvoiceDetailSuccess = (payload) => ({
  type: GET_AFFILIATE_INVOICE_DETAIL.SUCCESS,
  payload,
});

export const getAffiliateInvoiceDetailError = (payload) => ({
  type: GET_AFFILIATE_INVOICE_DETAIL.ERROR,
  payload,
});

export const getAffiliateInvoiceDetail = (invoiceId) => {
  return (dispatch) => {
    dispatch(getAffiliateInvoiceDetailStart());
    affiliateServices.getAffiliateInvoiceDetail(invoiceId).then((data) => {
      if (!data.isError) {
        dispatch(getAffiliateInvoiceDetailSuccess(data));
      } else {
        dispatch(getAffiliateInvoiceDetailError(data));
      }
    });
  };
};
